// extracted by mini-css-extract-plugin
module.exports = {"pane":"pane-module__pane___3CYRE"};